import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export function formatApiError(detail, fallback = "Something went wrong. Please try again.") {
    if (detail == null) return fallback;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const STORE = {
    name: "Freddie's Afro Caribbean Store",
    address: "33–35 Whitley Street, Reading, RG2 0EG, United Kingdom",
    addressShort: "33–35 Whitley Street, Reading, RG2 0EG",
    phones: [
        { label: "0118 229 5059", tel: "+441182295059" },
    ],
    whatsapp: { label: "07702 345773", url: "https://wa.me/447702345773" },
    email: "contact@freddiesafrocaribbean.co.uk",
    // Opening hours by JS weekday (0=Sunday .. 6=Saturday), 24h
    openingHours: { 0: [10, 20], 1: [9, 21], 2: [9, 21], 3: [9, 21], 4: [9, 21], 5: [9, 21], 6: [9, 21] },
    hours: [
        { days: "Monday – Saturday", time: "9:00 am – 9:00 pm" },
        { days: "Sunday", time: "10:00 am – 8:00 pm" },
    ],
    directionsUrl:
        "https://www.google.com/maps/dir/?api=1&destination=Freddies+Afro+Caribbean+Store%2C+33-35+Whitley+Street%2C+Reading+RG2+0EG%2C+UK",
    mapEmbedUrl:
        "https://www.google.com/maps?q=Freddies%20Afro%20Caribbean%20Store%2C%2033-35%20Whitley%20Street%2C%20Reading%20RG2%200EG&output=embed",
};
